import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "./services/auth/auth-guard.service";
import { TokenGuardService } from "./services/auth/token-guard.service";
import { OptOutComponent } from "./view/admin-client/opt-out/opt-out.component";
import { StopAutoEmailsComponent } from "./view/admin-client/stop-auto-emails/stop-auto-emails.component";
import { ForgotPasswordComponent } from "./view/auth/forgot-password/forgot-password.component";
import { LoggedOutComponent } from "./view/auth/logged-out/logged-out.component";
import { LoginComponent } from "./view/auth/login/login.component";
import { MFAVerificationComponent } from "./view/auth/mfa-verification/mfa-verification.component";
import { ReportComponentComponent } from "./view/auth/report-component/report-component.component";
import { ResetPasswordComponent } from "./view/auth/reset-password/reset-password.component";
import { NotFoundComponent } from "./view/error/not-found/not-found.component";
import { OnlineFormComponent } from "./view/online-form/online-form.component";

const routes: Routes = [
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "logged-out",
    component: LoggedOutComponent,
  },
  {
    path: "forgot-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "mfa-verification",
    component: MFAVerificationComponent,
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
    data: { tokenScope: "resetPassword", fallbackRoute: "/login" },
    canActivate: [TokenGuardService],
  },
  {
    path: "practitioner-report",
    component: ReportComponentComponent,
  },
  {
    path: "opt-out/:uuid",
    component: OptOutComponent,
  },
  {
    path: "stop-auto-emails/:uuid",
    component: StopAutoEmailsComponent,
  },

  {
    path: "dashboard",
    canActivate: [AuthGuardService],
    loadChildren: () => import("./view/dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "client-dashboard",
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./view/dashboard-client/dashboard-client.module").then(
        (m) => m.ClientDashboardModule
      ),
  },
  {
    path: "admin-dashboard",
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./view/dashboard-admin/dashboard-admin.module").then((m) => m.AdminDashboardModule),
  },
  {
    path: "dro-dashboard",
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./view/dashboard-dro/dashboard-dro.module").then((m) => m.DRODashboardModule),
  },
  {
    path: "survey-products-dashboard",
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./view/dashboard-survey-products/dashboard-survey-products.module").then(
        (m) => m.DashboardSurveyProductsModule
      ),
  },
  {
    path: "user-device",
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./view/user-device/user-device.module").then((m) => m.UserDeviceModule),
  },
  {
    path: "user-admin",
    data: { adminDirectoryOnly: true },
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./view/user-admin/user-admin.module").then((m) => m.UserAdminModule),
  },
  {
    path: "audit-logger",
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./view/audit-logger/audit-logger.module").then((m) => m.AuditLoggerModule),
  },
  {
    path: "audit-logger-user-impersonation",
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import("./view/audit-logger-user-impersonation/audit-logger-user-impersonation.module").then(
        (m) => m.AuditLoggerUserImpersonationModule
      ),
  },
  {
    path: "questionnaire/:id",
    component: OnlineFormComponent,
  },
  {
    path: "s1/:id",
    component: OnlineFormComponent,
  },
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },

  {
    path: "404",
    component: NotFoundComponent,
  },
  {
    path: "**",
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
